<template>
  <file-uploader-vue @onFileChange="handleFileChange" :fileAccept="fileAccept">
    <slot v-if="!onlyUpload"></slot>
  </file-uploader-vue>
</template>

<script>
import fileUploaderVue from './file-uploader.vue';
import { Client } from 'minio';
import {
  getOSSClient,
  checkedFileType,
  checkFileSize,
  getFileName
} from '../../config/utils';
import OSS from 'ali-oss';
import { mapState } from 'vuex';
import Axios from 'axios';
import { UploadingFile } from '../../api/index';

export default {
  props: {
    onlyUpload: {
      type: Boolean,
      default: false
    },
    fileSize: {
      type: Number,
      default: 20
    },
    fileAccept: {
      type: String,
      default: '.jpg,.png,.jpeg'
    },
    filePath: {
      type: String,
      default: 'photo'
    },
    param: {
      type: Object,
      default: () => ({})
    },
    customName: {
      type: String,
      default: ''
    }
  },
  components: {
    fileUploaderVue
  },
  computed: {
    ...mapState('login', ['visibleEx', 'minioOption'])
  },
  methods: {
    /**
     * 上传文件回调
     */
    async handleFileChange({
      files,
      param = {},
      customName = this.customName
    }) {
      try {
        checkedFileType(files, this.fileAccept);
        checkFileSize(files, this.fileSize);
        const client = this.visibleEx
          ? this.getMinioClient()
          : await getOSSClient(OSS);
        let promises = [];
        for (const file of Array.from(files)) {
          const promise = await this.uploadFile(file, client, param, customName);
          promises.push(promise);
        }
        return Promise.allSettled(promises);
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 文件上传
     * @param {File} file 待上传文件
     * @param {Object} client Oss配置
     */
    async uploadFile(file, client, param, customName) {
      return this.visibleEx
        ? this.uploadFileByMinio(file, client, param, customName)
        : this.uploadFileByAliOSS(file, client, param, customName);
    },

    /**
     * 工具函数
     * 上传数组带参数
     * @param {Array} fileList
     * @param {file} fileList[].file 必须为文件本体
     */
    async uploadFileParams(fileList) {
      const client = this.visibleEx
        ? this.getMinioClient()
        : await getOSSClient(OSS);
      const promiseList = [];
      fileList.forEach(async item => {
        promiseList.push(this.uploadFile(item.file, client, item));
      });
      return Promise.allSettled(promiseList);
    },

    /**
     * 格式化工具函数返回结果
     */
    // async formatUploadFileParams(fileList) {
    //   const data = await this.uploadFileParams(fileList);
    //
    // },
    /**
     * 使用ali-oss上传
     * @param {File} file 待上传文件
     * @param {Object} client Oss配置
     */
    async uploadFileByAliOSS(file, client, param, customName) {
      try {
        const fileName = customName || getFileName(file);
        const path = `xiaoshan/${this.filePath}/${fileName}`;
        let result = await client.multipartUpload(path, file);
        const requestUrl = result.res.requestUrls[0];
        const url = this.formatAliOSSUrl(requestUrl, fileName);
        this.$emit('onUploadSuccess', url, param);
        return { result, url, param };
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * minio上传文件
     */
    async uploadFileByMinio(file, client, param, customName) {
      const fileName = customName || getFileName(file);
      const filePath = `${this.filePath}/${Date.now()}/${fileName}`;
      const {
        data: { data: url }
      } = await UploadingFile(file, filePath);
      // console.log(data);
      // const test = await client.presignedPutObject(
      //   this.minioOption.bucketName,
      //   filePath
      // );

      // const url =
      //   test.split(this.minioOption.bucketName)[0] +
      //   this.minioOption.bucketName +
      //   '/' +
      //   filePath;

      // const headers = { Authorization: null };
      // await Axios.put(test, file, { headers });
      this.$emit('onUploadSuccess', url, param);
      return { url, param };
    },

    /**
     * minio上传请求
     */

    /**
     * 格式化ali url
     * @param {string} data 返回路径信息
     * @param {string} fileName 用户名
     */
    formatAliOSSUrl(data, fileName) {
      const base = data.split('/').pop();
      return data.replace(base, fileName);
    },

    /**
     * 获取minioClient
     */
    getMinioClient() {
      return {};
      // const {
      //   endPoint,
      //   accessKey,
      //   secretKey,
      //   bucketName,
      //   port
      // } = this.minioOption;
      // const useSSL = JSON.parse(process.env.VUE_APP_VISIBLE_SSL);
      // const options = {
      //   endPoint,
      //   accessKey,
      //   secretKey,
      //   useSSL,
      //   port
      // };
      // return new Client(options);
    }
  }
};
</script>

<style lang="scss" scoped></style>
